import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TelegramService {
  telegramLink: string = ' https://api.telegram.org/bot';
  botAuthorisationToken: string = '1951179088:AAGmHp9Qb89m5uVDMkFqEBhPTThJq3XeFKM';
  chatId: string = '-534411810';
  helpChatId: string = '-534411810';
  url: string;

  constructor(private http: HttpClient) {
  }

  SubmitAnApplication(fio: string, email: string, phone: string) {
    let message = 'Абитуриент желает подать документы' + '%0A%0A' + fio + '%0A' + email + '%0A' + '8' + phone;
    this.url = this.telegramLink + this.botAuthorisationToken + '/sendMessage?chat_id=' + this.chatId + '&text=' + message;
    return this.http.get<any>(this.url).subscribe(value => {
    });
  }

  HelpChat(fio: string, phone: string, email: string) {
    let message = 'Обращение к службе поддержки' + '%0A%0A' + fio + '%0A' + email + '%0A' + '8' + phone;
    this.url = this.telegramLink + this.botAuthorisationToken + '/sendMessage?chat_id=' + this.helpChatId + '&text=' + message;
    return this.http.get<any>(this.url).subscribe(value => {
    });
  }
}
